import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/.pruned/json/apps/web-app/src/components/Toast/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BugsnagErrorBoundary"] */ "/app/.pruned/json/apps/web-app/src/lib/_utils/bugsnag.ts");
;
import(/* webpackMode: "eager", webpackExports: ["EventsProvider"] */ "/app/.pruned/json/apps/web-app/src/providers/EventsProvider/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/.pruned/json/apps/web-app/src/style/global.css");
;
import(/* webpackMode: "eager" */ "/app/.pruned/json/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/app/.pruned/json/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/app/.pruned/json/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/.pruned/json/node_modules/next-translate/lib/esm/AppDirI18nProvider.js");
;
import(/* webpackMode: "eager" */ "/app/.pruned/json/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/.pruned/json/node_modules/next/font/local/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"\",\"arguments\":[{\"src\":\"../../../../packages/fonts/anuphan-latin.woff2\",\"display\":\"swap\",\"variable\":\"--font-anuphan\"}],\"variableName\":\"anuphan\"}");
;
import(/* webpackMode: "eager" */ "/app/.pruned/json/node_modules/next/font/local/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"\",\"arguments\":[{\"src\":\"../../../../packages/fonts/darker-grotesque-latin.woff2\",\"display\":\"swap\",\"variable\":\"--font-darker-grotesque\"}],\"variableName\":\"darker_grotesque\"}");
;
import(/* webpackMode: "eager", webpackExports: ["NuqsAdapter"] */ "/app/.pruned/json/node_modules/nuqs/dist/adapters/next/app.js");
